import React, { useState } from "react";
import "../assets/style/Applicationstatus.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateData } from "../redux/roundtoSlice";
import VerifiedUserWhite from "../assets/images/VerifiedUserWhite.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import { Tooltip } from "react-tooltip";


export default function QuizNoteReady() {

  const state = useSelector(state => state?.roundData)
  const dispatch = useDispatch()




  const [step, setStep] = useState(2);

  const navigate = useNavigate()
  const handleStartPersonalityTest = () => {
    setStep(2);
  };

  const handleStartMcqQuiz = () => {
    setStep(3);
  };



  const editProfile = () => {


    dispatch(updateData({ field: 'isEditDetails', value: true }))
    navigate("/JobApplicationProcess", { state: { fromOtherPage: true } })


  }


  return (
    <div className="status-main1">
      <div className="status-container">
        <p className="greeting">Dear {state.userName},</p>
        {
          state?.applicationType === 'Internal Assessment' ?
            <div>
              <p className="desc" style={{ fontWeight: 500, fontFamily: "Inter-Regular" }} >Thank you for completing your behavioral assessment! </p>
              <p className="note" style={{ fontWeight: 500, fontFamily: "Inter-Regular" }}>We’ll be sharing your personality profile with you via email shortly. Stay tuned - we’re excited for you to explore it!</p>
            </div> :

            <>
              <p className="thank-you">Thank you !</p>
              <p className="step-status">
                Application Status - {step} of 3 Steps Complete
              </p>

              <div className="step-circles">
                <div className={`step ${step >= 1 ? "active" : ""}`}>
                  <div className="circle">1</div>
                  <p>Basic Info</p>
                </div>
                <div className={`step ${step >= 2 ? "active" : ""}`}>
                  <div className="circle">2</div>
                  <p>Personality Test</p>
                </div>
                <div className={`step ${step >= 3 ? "active" : ""}`}>
                  <div className="circle">3</div>
                  <p>Short Quiz</p>
                </div>
              </div>

              {step === 1 && (
                <>
                  <p className="desc" style={{ fontWeight: 600 }}>
                    Your Resume alone doesn’t give the full picture !
                  </p>
                  <button
                    className="personality-btn"
                    onClick={handleStartPersonalityTest}
                  >
                    Start Personality Test <span className="arrow">▶</span>
                  </button>
                  <p className="test-time">Test Time: Approx. 8 minutes</p>
                  <p className="know-you" style={{ fontWeight: 600 }}>
                    Allow us to know you better !
                  </p>
                  <p className="note" style={{ fontWeight: 600 }}>
                    Stressful / Short Interviews don’t give us the opportunity.
                  </p>
                </>
              )}

              {step === 2 && (
                // <>
                //   <p className="desc">Your Personality has been mailed to you also</p>
                //   <button className="personality-btn" onClick={handleStartMcqQuiz}>
                //     Start MCQ Quiz <span className="arrow">▶</span>
                //   </button>
                //   <p className="test-time">Test Time: Approx. 8 minutes</p>
                //   <p className="know-you">Demonstrate your basic skills.</p>
                //   <p className="note">Avoid uncomfortable Pre Screening calls !</p>
                // </>
                <>
                  <p className="desc" style={{ fontWeight: 600 }}>
                    Your Personality has been mailed to you also
                  </p>
                  {/* <button className="personality-btn exit-btn"
                    onClick={() => navigate('/LoginWithCode')}
                  >
                    Exit <span className="arrow" data-label="exit-icon"></span>
                  </button> */}
                  <p className="note" style={{ fontWeight: 600 }}>
                    Your Quiz is Not Ready Yet !
                  </p>
                  <p className="note" style={{ fontWeight: 600 }}>
                    You will receive an email once your Quiz is ready.
                  </p>
                </>
              )}
            </>
        }
      </div>
      <div className="dsktp-footer">
        <div className="dsktp-footer-right">
          {/* <div className='lang-dsktp'>
                           <img src={languageIcon} className="mobIcon" alt="Select language" />
                           <p>Behavior test Language</p>
                           <div className='langbox-dsktp' onClick={() => setShowLanguagePopup(true)}>
                               <p>English</p>
                               <img src={arrowUp} className="mobIcon" alt="Select language" />
                           </div>
                       </div> */}

          <button
            className="comp-savebtn"
            // onClick={editProfile}
            style={{ width: "120px", padding: "8px 14px", height: "40px" }}

            data-tooltip-id="edit-btn"
            data-tooltip-place="top-start"
          >
            Edit Profile

            <Tooltip style={{ width: "220px" }} id="edit-btn">You don’t have permission to Edit Profile from here</Tooltip>
          </button>
        </div>
        <div className="dsktp-footer-left">
          <div className="dsktp-footerjob-info">
            <div className="v-u-jobcode">
              <h6 style={{ display: "flex", justifyContent: "end" }}>
                {state.code}
              </h6>
              <p>
                This application Process is Managed by <span>LYWO</span>
              </p>
            </div>
            <div className="v-u-bg">
              <img src={VerifiedUserWhite} className="vu-icon" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-icons-mcq">

        <div className="mobile-icon-txt" onClick={editProfile}>
          <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
          <p>Edit Profile</p>
        </div>
      </div>
    </div>
  );
}
